<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>培训中老师</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="HR">
              <Select v-model="queryParam.hr" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.hrList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <!--          <i-col :xs="24" :sm="12" :md="8" :lg="3">
                      <Form-item label="类型">
                        <Select v-model.number="queryParam.category" placeholder="全部"
                                @on-change="search" clearable>
                          <Option v-for="item in teacherCategoryList"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>-->
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="是否分配外教运营" :label-width="109">
              <Select v-model.number="queryParam.isStudyAdviser" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.isStudyAdviser"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="口音：" :label-width="80">
              <Select v-model.number="queryParam.accent" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.accent"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="性别：" :label-width="80">
              <Select v-model.number="queryParam.sex" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.sex"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <Row :gutter="12">
          <i-col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="老师ID" prop="id">
              <Input name="id" v-model="queryParam.id"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="老师昵称">
              <Input name="name" placeholder="支持模糊搜索"
                     v-model="queryParam.name"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="老师账号">
              <Input name="account" placeholder="支持模糊搜索"
                     v-model="queryParam.account"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="授课类型" prop="tchType">
              <Select v-model.number="queryParam.tchType" placeholder="全部"
                      @on-change="search" clearable data-value="-1" transfer>
                <Option value="-1">全部</Option>
                <Option v-for="item in $constant.tchType"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="来源：">
              <Select v-model.number="queryParam.channel" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="5">
            <Form-item label="注册渠道">
              <Select v-model="queryParam.regFrom" placeholder="全部" clearable @on-change="search" transfer style="width: 100%">
                <Option v-for="item in channelOptions" :value="item.param" :key="item.id">{{ item.status === 0 ? (item.name + '（停用）') : item.name }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="推荐人">
              <Input name="inviteTchName" placeholder="推荐人姓名"
                     v-model="queryParam.inviteTchName"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="注册时间">
              <DatePicker @on-change="createDateChange" format="yyyy-MM-dd" type="daterange"
                          clearable placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </i-col>
        </Row>
      </Form>

      <div class="button-container">

        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>

        <div class="spacer"></div>

        <Row>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" @click="exportData">导出</Button>
          <Button type="primary" @click="allTeachersLeave">全体老师请假</Button>
          <Button type="primary" @click="batchReject">批量拒绝</Button>
          <Button type="primary" @click="onAssignAdviser">分配外教运营</Button>
          <Button type="primary" @click="addTch">添加老师</Button>
        </Row>

      </div>


    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/tch/training/list"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>

    <TchCancelOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                              v-model="showTchCancelOpenedTimeModal"></TchCancelOpenedTimeModal>

    <TchAddOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                           v-model="showTchAddOpenedTimeModal"></TchAddOpenedTimeModal>
    <TchEditOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                            v-model="showTchEditOpenedTimeModal"></TchEditOpenedTimeModal>

    <TchCancelRandomOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                                    v-model="showCancelRandomOpenedTimeModal"></TchCancelRandomOpenedTimeModal>

    <TchAddRandomOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                                 v-model="showTchAddRandomOpenedTimeModal"></TchAddRandomOpenedTimeModal>

    <TchLeaveModal :tchId="tchId" :substituteList="substituteList"
                   v-model="showTchLeaveModal" @getProxyClassData="showProxyClass"
                   @getCancelProxyClassData="cancelProxyClassData"></TchLeaveModal>

    <TchLeaveOfficeModal :tchId="tchId" :substituteList="substituteList"
                         v-model="showTchLeaveOfficeModal" @getProxyClassData="showProxyClass"
                         @getCancelProxyClassData="cancelProxyClassData"></TchLeaveOfficeModal>

    <AssignTchStudyAdviserModal :successCallback="searchWithPage" :tchList="selectionTch"
                                v-model="showAssignTchStudyAdviserModal"></AssignTchStudyAdviserModal>

    <TchInsertModal :successCallback="searchWithPage" v-model="tchInsertModal"></TchInsertModal>

    <AllTeachersLeaveModal v-model="showAllTeacherLeaveModel"></AllTeachersLeaveModal>

    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage" :addType="addType" recruit-flow-entry="培训中老师"></tch-info-modal>
    <EditDingDingModal :tchId="tchId" :value="showEditDingModal" @on-close="closeEditDingModal"
                       :successCallback="searchWithPage"></EditDingDingModal>
    <TeachersDingTalkModal :tchId="tchId" :value="showTeacherDingTalkModal" @on-close="closeTeacherDingTalkModal"
                           :successCallback="searchWithPage"></TeachersDingTalkModal>

    <Modal v-model="showSelectTch" title="选择代课老师">
      <Form model="selectTchParam">
        <Row :gutter="12">
          <Col span="12">
            课节时间：{{ lsnBeginTime }}
          </Col>
          <Col span="12">
            学生姓名：{{ selectTchParam.uid + '-' + selectTchParam.userNickname }}
          </Col>
        </Row>
        <Row :gutter="12">
          <Col span="12">
            学习导师：{{ selectTchParam.studyAdviserNickname }}
          </Col>
          <Col span="12">
            课程顾问：{{ selectTchParam.adviserNickname }}
          </Col>
        </Row>
        <Row :gutter="12">
          <Col span="16">
            <Form-item label="代课老师：" :label-width="80">
              <substitute-tch-select :dataL="activityList" v-model="substituteTchId"
                                     :openedId="selectTchParam.openedId"></substitute-tch-select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showSelectTch=false">取消</Button>
        <Button type="primary" size="large" @click="updateTch">保存</Button>
      </div>
    </Modal>
    <Modal title="审核拒绝" v-model="showRejectModal">
      <Form ref="rejectForm" class="form"
            :model="rejectParam" :rules="rejectRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item style="margin-bottom: 10px">
              <label>确定 <b>{{ rejectParam.id }} - {{ rejectParam.firstName }} {{ rejectParam.lastName }}</b> 老师未审核通过</label>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="类型" prop="leaveKind">
              <RadioGroup v-model="rejectParam.leaveKind">
                <Radio :label="1">淘汰</Radio>
                <Radio :label="2">流失</Radio>
              </RadioGroup>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="理由" prop="remark">
              <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                     placeholder="长度不要超过100个字"
                     v-model="rejectParam.remark"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showRejectModal=false">取消</Button>
        <Button type="error" size="large" :loading="loadingReject" @click="reject">拒绝</Button>
      </div>
    </Modal>
    <Modal width="800"
           v-model="showTchChangeModal"
           title="操作记录">
      <Table :columns="tchChangeStatusColumn" :data="tchChangeStatusList"></Table>
      <div slot="footer"></div>
    </Modal>
    <send-email-modal :visible="showEmailModal" @on-close="showEmailModal=false" :tchId="emailTchId" :tchName="emailTchName" :successCallback="search"></send-email-modal>
    <tch-apply-form-modal :visible="showApplyModal" @on-close="showApplyModal=false" :tchId="applyTchId"></tch-apply-form-modal>
    <Modal title="批量审核" v-model="showBatchReviewModal">
      <Form ref="reviewForm" class="form" :model="reviewParam" :rules="rejectRule" :label-width="90">
        <Row>
          <Col :span="22">
            <Form-item label="待审核老师：">
              <Tag v-for="item in selectionTch" :key="item.id" :name="item.id">
                {{ item.id + ' - ' + item.firstName + ' ' + item.lastName }}
              </Tag>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="类型：" prop="leaveKind">
              <RadioGroup v-model="reviewParam.leaveKind">
                <Radio :label="1">淘汰</Radio>
                <Radio :label="2">流失</Radio>
              </RadioGroup>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="理由：" prop="remark">
              <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                     placeholder="长度不要超过100个字"
                     v-model="reviewParam.remark"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" @click="batchReview">拒绝</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import TchCancelOpenedTimeModal from './TchCancelOpenedTimeModal.vue'
import TchAddOpenedTimeModal from './TchAddOpenedTimeModal.vue'
import TchEditOpenedTimeModal from './TchEditOpenedTimeModal.vue'
import TchCancelRandomOpenedTimeModal from './TchCancelRandomOpenedTimeModal.vue'
import TchAddRandomOpenedTimeModal from './TchAddRandomOpenedTimeModal.vue'
import TchLeaveModal from './TchLeaveModal.vue'
import TchLeaveOfficeModal from './TchLeaveOfficeModal.vue'
import AssignTchStudyAdviserModal from './modal/AssignTchStudyAdviserModal.vue'
import TchInsertModal from './TchInsertModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import AllTeachersLeaveModal from './AllTchLeaveModal'
import EditDingDingModal from './modal/EditDingDingModal'
import TeachersDingTalkModal from './modal/TeachersDingTalkModal'
import SubstituteTchSelect from '@/components/common/SubstituteTchSelect'
import SendEmailModal from './modal/SendEmailModal.vue'
import TchApplyFormModal from './modal/TchApplyFormModal.vue'

export default {
  components: {
    SendEmailModal,
    TchApplyFormModal,
    TeachersDingTalkModal,
    EditDingDingModal,
    TchCancelOpenedTimeModal,
    TchAddOpenedTimeModal,
    TchEditOpenedTimeModal,
    TchCancelRandomOpenedTimeModal,
    TchAddRandomOpenedTimeModal,
    TchLeaveModal,
    TchLeaveOfficeModal,
    AssignTchStudyAdviserModal,
    TchInsertModal,
    AllTeachersLeaveModal,
    TchInfoModal,
    SubstituteTchSelect
  },
  name: 'tchTrainingList',
  data: function () {
    let $moment = this.$moment
    let $constant = this.$constant
    return {
      reviewParam: {
        ids: '',
        remark: '',
        leaveKind: null
      },
      rejectRule: {
        leaveKind: [
          {required: true, type: 'number', message: '请选择淘汰或流失', trigger: 'change'}
        ],
        remark: [
          {type: 'string', required: true, message: '理由不能为空', trigger: 'blur'},
          {type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur'},
          {
            validator: function (rule, value, callback) {
              if (!value || !String(value).trim()) {
                callback(new Error('理由不能为空'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      showApplyModal: false,
      applyTchId: null,
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      loadingReject: false,
      showRejectModal: false,
      showBatchReviewModal: false,
      rejectParam: {
        id: '',
        remark: '',
        leaveKind: null
      },
      exportLoading: false,
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [
        {
          title: '修改类别',
          render: (h, params) => {
            let type = params.row.type
            let typeEnum = $constant.getEnum($constant.tchChangeStatusType, type)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '原来状态',
          render: (h, params) => {
            let row = params.row
            let oldStatus = row.oldStatus
            let type = row.type
            if (type === 1) {
              let oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus)
              return h('span', oldStatusEnum && oldStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.oldNickname || '')
            }
            return h('span', oldStatus)
          }
        },
        {
          title: '现在状态',
          render: (h, params) => {
            let row = params.row
            let newStatus = row.newStatus
            let type = row.type
            if (type === 1) {
              let newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus)
              return h('span', newStatusEnum && newStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.newNickname || '')
            }
            return h('span', newStatus)
          }
        },
        {
          title: '操作人',
          key: 'adminNickname'
        },
        {
          title: '操作时间',
          width: 170,
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '理由',
          key: 'remark'
        }
      ],
      showTchInfoModal: false,
      tchId: null,
      addType: null,
      queryParam: {
        hr: '',
        sex: '',
        accent: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        category: 4,
        channel: '',
        regFrom: '',
        startCreateDate: '',
        endCreateDate: '',
      },
      channelOptions: [],
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: $constant.teacherCategory.filter(item => item.code !== 6),
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '', // 学习导师
        adviser: '', // 课程顾问
        openedId: '',
        substituteTchId: ''
      },
      title: [
        {
          type: 'selection',
          width: 40,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '老师ID',
          width: 80,
          fixed: 'left',
          align: 'center',
          key: 'id'
        },
        {
          title: '老师昵称',
          width: 140,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.firstName + row.lastName,
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.id)
            })
          }
        },
        {
          title: 'Full Name',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.fullName,
                placeholder: 'Full Name'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.fullName) {
                    row.fullName = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, fullName: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.fullName) {
                    row.fullName = value
                    this.updateTchDirect({tchForm: {tchId: row.id, fullName: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '真实国籍',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.nationality || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.nationality,
                placeholder: '真实国籍'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.nationality) {
                    row.nationality = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, nationality: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.nationality) {
                    row.nationality = value
                    this.updateTchDirect({tchForm: {tchId: row.id, nationality: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '现居地',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.address || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.address,
                placeholder: 'address',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.address) {
                    row.address = newValue
                    this.updateTchDirect({tchInfo: {tchId: row.id, address: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.address) {
                    row.address = value
                    this.updateTchDirect({tchInfo: {tchId: row.id, address: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '外教等级',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.tchLevel || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.tchLevel,
                placeholder: '等级'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.tchLevel) {
                    row.tchLevel = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, tchLevel: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.tchLevel) {
                    row.tchLevel = value
                    this.updateTchDirect({tchForm: {tchId: row.id, tchLevel: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: 'FM',
          key: 'studyAdviserNickname',
          width: 120,
          align: 'center',
        },
        {
          title: 'HR',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.hr || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.hr,
                placeholder: 'hr'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.hr) {
                    row.hr = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, hr: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.hr) {
                    row.hr = value
                    this.updateTchDirect({tchForm: {tchId: row.id, hr: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '推荐人',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.inviteTchName || '',
                placeholder: '输入推荐人ID'
              },
              style: { width: '160px' },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== (row.inviteTchName || '')) {
                    row.inviteTchName = newValue
                    this.updateInviteTch(row, newValue)
                  }
                },
                'on-enter': (event) => {
                  const val = event.target ? event.target.value : event
                  if (val !== (row.inviteTchName || '')) {
                    row.inviteTchName = val
                    this.updateInviteTch(row, val)
                  }
                }
              }
            })
          }
        },
        {
          title: '注册渠道',
          width: 100,
          align: 'center',
          key: 'regFrom'
        },
        {
          title: '进度',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.progressRemark || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.progressRemark,
                placeholder: 'remark',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.progressRemark) {
                    row.progressRemark = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, progressRemark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.progressRemark) {
                    row.progressRemark = value
                    this.updateTchDirect({tchForm: {tchId: row.id, progressRemark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '周末时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.weekendRemark || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.weekendRemark,
                placeholder: 'remark',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.weekendRemark) {
                    row.weekendRemark = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, weekendRemark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.weekendRemark) {
                    row.weekendRemark = value
                    this.updateTchDirect({tchForm: {tchId: row.id, weekendRemark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '预计开课时间',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('DatePicker', {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                value: row.openCourseTime,
                placeholder: '选择日期',
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  if (value !== row.openCourseTime) {
                    row.openCourseTime = value
                    this.updateTchDirect({tchForm: {tchId: row.id, openCourseTime: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '性别',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.sex,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.sex = value
                  this.updateTchDirect({tchList: {id: row.id, sex: value}})
                }
              }
            }, this.$constant.sex.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '口音',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.accent,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.sex = value
                  this.updateTchDirect({tchInfo: {tchId: row.id, accent: value}})
                }
              }
            }, this.$constant.accent.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '老师账号',
          width: 250,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.account,
                placeholder: 'Login Account'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.account) {
                    row.account = newValue
                    this.updateTchDirect({tchList: {id: row.id, account: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.account) {
                    row.account = value
                    this.updateTchDirect({tchList: {id: row.id, account: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '试用期时薪',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.probationHourlySalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.probationHourlySalary,
                placeholder: '试用期时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.probationHourlySalary) {
                    row.probationHourlySalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, probationHourlySalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.probationHourlySalary) {
                    row.probationHourlySalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, probationHourlySalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '试用期课薪',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.probationClassSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.probationClassSalary,
                placeholder: '试用期课薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.probationClassSalary) {
                    row.probationClassSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, probationClassSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.probationClassSalary) {
                    row.probationClassSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, probationClassSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '转正时薪',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.regularHourlySalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.regularHourlySalary,
                placeholder: '转正时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.regularHourlySalary) {
                    row.regularHourlySalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, regularHourlySalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.regularHourlySalary) {
                    row.regularHourlySalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, regularHourlySalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '转正课薪',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.regularClassSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.regularClassSalary,
                placeholder: '转正课薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.regularClassSalary) {
                    row.regularClassSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, regularClassSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.regularClassSalary) {
                    row.regularClassSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, regularClassSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '期望时薪',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.expectSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.expectSalary,
                placeholder: '期望时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.expectSalary) {
                    row.expectSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, expectSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.expectSalary) {
                    row.expectSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, expectSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '最高学历',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.eduLevel || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.eduLevel,
                placeholder: '最高学历'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.eduLevel) {
                    row.eduLevel = newValue
                    this.updateTchDirect({tchList: {id: row.id, eduLevel: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.eduLevel) {
                    row.eduLevel = value
                    this.updateTchDirect({tchList: {id: row.id, eduLevel: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '合同开始时间',
          key: 'crtBeginTimeStr',
          width: 120,
          align: 'center',
        },
        {
          title: '合同结束时间',
          //  key: 'crtEndTimeStr',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let day = row.crtEndTimeDay
            let crtEndTimeStr = row.crtEndTimeStr
            if (crtEndTimeStr) {
              if (day <= 30) {
                return h('div', [
                  h('p', {}, row.crtEndTimeStr),
                  h('span', {style: {color: 'red'}}, '距结束' + day + '天')
                ])
              } else {
                return h('div', [
                  h('p', {}, row.crtEndTimeStr),
                ])
              }
            }
          }
        },
        {
          title: '最近跟踪',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let trackTime = params.row.trackTime
            let trackContent = params.row.trackContent
            return h('div', [
              h('div', {
                attrs: {
                  title: trackContent // 鼠标悬停时显示完整内容
                },
                style: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, trackContent || ''),
              h('div', {
                style: {
                  fontSize: '12px',
                  color: '#999',
                  marginTop: '4px'
                }
              }, trackTime || '')
            ])
          }
        },
        {
          title: '操作日志',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let self = this
            let isTchChange = params.row.isTchChange
            let id = params.row.id
            if (isTchChange) {
              return h('a', {
                on: {
                  click: () => {
                    self.onTchChangeStatusList(id)
                  }
                }
              }, '查看')
            } else {
              return h('span', '无记录')
            }
          }
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let operationArr = []
            if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
              operationArr.push(h('a', {
                on: {
                  click: () => {
                    this.onShowApply(row)
                  }
                }
              }, '注册资料'))
            }
            if (row.category === 4) {
              if (operationArr.length) {
                operationArr.push(h('span', {class: 'divider'}))
              }
              operationArr.push(h('a', {
                on: {
                  click: () => {
                    this.onOpenClass(row)
                  }
                }
              }, '开课'))
              operationArr.push(h('span', {class: 'divider'}))
              operationArr.push(h('a', {
                on: {
                  click: () => {
                    this.onReject(row)
                  }
                }
              }, '拒绝'))
              operationArr.push(h('span', {class: 'divider'}))
              operationArr.push(h('a', {on: { click: () => { this.onSendEmail(row) } }}, '发送邮件'))
            }
            if (!operationArr.length) {
              return h('span', '')
            }
            return h('div', operationArr)
          }
        }
      ]
    }
  },
  mounted: function () {
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },

  created: function () {
    this.loadRegChannels()
  },

  methods: {
    loadRegChannels () {
      let self = this
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data
        }
      })
    },
    onShowApply (row) {
      this.applyTchId = row.id
      this.showApplyModal = true
    },
    onSendEmail (row) {
      this.emailTchId = row.id
      this.emailTchName = row.firstName + ' ' + row.lastName
      this.showEmailModal = true
    },
    updateTchDirect (req) {
      this.$http.post('/tch/update-direct', req).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
    onReject (row) {
      this.showRejectModal = true
      this.rejectParam.id = row.id
      this.rejectParam.firstName = row.firstName
      this.rejectParam.lastName = row.lastName
      this.rejectParam.leaveKind = null
      this.rejectParam.remark = ''
    },
    reject () {
      let self = this
      self.loadingReject = true
      self.$refs.rejectForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingReject = false
          return
        }
        let params = {}
        params.id = self.rejectParam.id
        params.remark = self.rejectParam.remark ? self.rejectParam.remark.trim() : ''
        params.leaveKind = self.rejectParam.leaveKind
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.search()
            self.showRejectModal = false
          }
          self.loadingReject = false
        }).catch(function (e) {
          self.showRejectModal = false
          self.loadingReject = false
        })
      })
    },
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },

    closeModal (val) {
      this.uid = null
      this.editUser = val
    },

    search () {
      this.reload = new Date().getTime()
    },
    createDateChange (value) {
      this.queryParam.startCreateDate = (value && value[0]) || ''
      this.queryParam.endCreateDate = (value && value[1]) || ''
      this.search()
    },

    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },

    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.id }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'id', 'monthRankScore', map)
      })
    },

    onTchChangeStatusList (tchId) {
      let self = this
      self.tchChangeStatusList = []
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true
        if (!res || !res.data) {
          return
        }
        self.tchChangeStatusList = res.data
      })
    },

    selectionChange (selection) {
      this.selectionTch = selection
    },

    // 分配外教运营
    onAssignAdviser () {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！')
        return
      }
      this.showAssignTchStudyAdviserModal = true
    },
    batchReview () {
      let self = this
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！')
        return
      }
      self.$refs.reviewForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        let idList = self.selectionTch.map(function (element) {
          return element.id
        })
        self.reviewParam.ids = idList.join(',')
        self.reviewParam.remark = self.reviewParam.remark ? self.reviewParam.remark.trim() : ''
        self.$http.post('/tch/batchReject', self.reviewParam).then(function (res) {
          self.$Message.success('审核成功')
          self.showBatchReviewModal = false
          self.selectionTch = []
          self.search()
        }).catch(function (e) {
          self.$Message.error('审核失败')
          self.showBatchReviewModal = false
          self.selectionTch = []
          self.search()
        })
      })
    },
    batchReject () {
      let self = this
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！')
        return
      }
      this.reviewParam.leaveKind = null
      this.reviewParam.remark = ''
      this.showBatchReviewModal = true
    },
    // 让老师进入试用期
    onOpenClass (row) {
      let self = this
      let name = row.id + ' - ' + row.firstName + ' ' + row.lastName
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + name + '</b> 老师进入试用期？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/tch/openClass', {id: row.id}).then(function (res) {
            self.search()
            self.$Message.success('开课成功!')
            self.$Modal.remove()
          })
        }
      })
    },

    addTch () {
      this.showTchInfoModal = true
      this.tchId = null
      this.addType = 'training'
    },

    allTeachersLeave () {
      this.showAllTeacherLeaveModel = true
    },

    closeEditDingModal () {
      this.showEditDingModal = false
      this.tchId = null
    },

    closeTeacherDingTalkModal () {
      this.showTeacherDingTalkModal = false
      this.tchId = null
    },

    showProxyClass (row) {
      let self = this
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm')
      self.selectTchParam = row
      self.showSelectTch = row.show
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data
        } else {
          self.activityList = []
        }
      })
    },

    cancelProxyClassData (row) {
      let self = this
      row.isProxy = 0
      self.activityList.map((item, index) => {
        if (item.id === row.id) {
          self.activityList[index].replace(item, row)
        }
      })
    },

    updateTch () {
      let self = this
      self.selectTchParam.isProxy = 1
      console.log(`self.substituteTchId`, self.substituteTchId)
      if (self.substituteTchId == null || self.substituteTchId === '') {
        self.$message.warning('请选择代课老师')
        return
      }
      self.selectTchParam.substituteTchId = self.substituteTchId
      if (self.substituteList.find(item => self.selectTchParam.id === item.id) == null) {
        self.substituteList.push(self.selectTchParam)
      }
      self.showSelectTch = false
    },
    exportData () {
      this.exportLoading = true
      this.$http({
        method: 'post',
        url: '/tch/training/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '培训中老师.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
      }).catch((e) => {
        this.$Message.error('导出失败')
        this.exportLoading = false
      })
    },

    updateInviteTch (row, val) {
      const inviteId = parseInt(val)
      if (!inviteId || inviteId <= 0) {
        this.$Message.warning('请输入有效的推荐人ID')
        return
      }
      this.$http.post('/tch/update-referrer', { newTchId: row.id, inviteId: inviteId }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('推荐人更新成功')
          this.searchWithPage()
        } else {
          this.$Message.error(res.msg || '更新失败')
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    }
  },

  watch: {}
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 10px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// TchTrainingList.vue?56f3d37c